const footerBt = {
	company: 'གྲམ་གྱི་ཚོང་ཁང་',
	description: 'འབྲུག་ཡུལ་ནང་གསར་ཤོས་ཆེས་ཆེར་བཟོས་པའི་དྲ་ཐོག་ཚོང་མཛོད། ཉིན་རེའི་དགོས་མཁོ་ཡོངས་རྫོགས་འཐོབ།',
	links: {
		company: 'ཚོང་ལས་',
		business: 'ཚོང་པ་',
		support: 'རམ་འདེགས་',
		about: 'ང་ཚོའི་སྐོར་',
		career: 'ལས་བྱེད་',
		contact: 'འབུལ་བསྐུར་',
		help: 'རོགས་རམ་',
		becomeSeller: 'སྤྱིར་བཏང་བཙོང་པ་འགྱུར་',
		businessAccount: 'ཚོང་པའི་རྩིས་ཐོ་',
		marketplacePolicy: 'ཚོང་རིམ་གྱི་སློབ་ཚན་',
		deliveryPolicy: 'གཏོང་ལེན་སྲིད་ཚད་',
		returnPolicy: 'ལོག་སྤྲོད་སྲིད་ཚད་',
		privacyPolicy: 'གསང་བའི་སྲིད་ཚད་'
	},
	contact: {
		heading: 'འབུལ་བསྐུར་',
		address: 'དྷ་ཀ་ བངྒ་ལ་དེཤ་'
	},
	copyright: (year) => `© ${year} གྲམ་གྱི་ཚོང་ཁང་། དབང་ཆ་ཡོངས་སུ་ཉར་ཚགས།`
};

export default footerBt;


